var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergencyTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 78,
    viewBox: "0 0 78 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39C0 17.4609 17.4609 0 39 0C60.5391 0 78 17.4609 78 39C78 60.5391 60.5391 78 39 78C17.4609 78 0 60.5391 0 39Z",
    fill: "#ffbb00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8639 44.0506L25.6387 36.8816L21.666 40.8235L31.2006 50.2838L31.2115 50.2729L32.9522 52L55.0946 30.0185L51.0448 26L32.8639 44.0506Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergencyTick);
export default __webpack_public_path__ + "static/media/emergency-tick.97cc19635b22929629570d3892c390b0.svg";
export { ForwardRef as ReactComponent };